import { createAsyncThunk } from "@reduxjs/toolkit";
import apiClient from "../../../API/apiClient ";

export const GetReturn = createAsyncThunk(
  'Return/returnList',
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiClient.get('Return/GetReturnDetails');
      return response.data;  
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Error fetching Return Data');
    }
  }
);
export const GetReturnItems = createAsyncThunk(
  'Return/returnItems',
  async (DocEntry, { rejectWithValue }) => {
    console.log("docEntry",DocEntry);
    
    try {
      const response = await apiClient.get(`Return/ReturnItemsbyDocEntry?docEntry=${DocEntry}`);
      return response.data;  
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Error fetching Return Data');
    }
  }
);

export const GetInvoiceDetail = createAsyncThunk(
  'Return/InvoiceDetail',
  async (DocEntry, { rejectWithValue }) => {
    try {
      const response = await apiClient.get(`/Return/GetInvoiceData?docEntry=${DocEntry}`);
      return response.data;  
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Error fetching Return Data');
    }
  }
);


export const  PostReturn = createAsyncThunk(
  'Return/PostreturnItems',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await apiClient.post(`Return/PostReturn`,payload);
      return response.data;  
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Error Return Posting');
    }
  }
);
